"use client";

import { useLink } from "@website/ui/link/link.hook";
import styles from "@website/ui/link/link.module.scss";
import { LinkPropertiesType } from "@website/ui/link/link.types";
import NextLink from "next/link";
import { forwardRef, ForwardRefExoticComponent } from "react";

export const Link: ForwardRefExoticComponent<any> = forwardRef<
  HTMLAnchorElement,
  LinkPropertiesType
>((properties, reference) => {
  const { children, className, color, disabled, StartIcon } = properties;
  const { rootProperties } = useLink(properties);

  return (
    <NextLink
      {...rootProperties}
      className={`${styles["link"]} ${styles[color ?? "primary"]} ${
        disabled ? styles["disabled"] : ""
      } ${className ?? ""}`}
      prefetch={false}
      ref={reference}
    >
      {StartIcon ? (
        <div className={styles["start-icon"]}>{StartIcon}</div>
      ) : null}
      <span itemProp="name">{children}</span>
    </NextLink>
  );
});
